import Api from './api'
import response from '../../../utils/response'
import { assign } from 'lodash'
import {LAYOUT_TYPE} from '../../constants/index'

/**
 * 方法名: requestSchema
 * 说明: 获取主对象
 * 参数:
 * 1. params 对象  {curAuthCode,layoutApiName,objectApiName,tenantType}
 * 2. headerParams 对象 => 校验权限
 * */
export async function requestSchema (params, headerParams) {
  const {getLayoutInfo} = Api
  const computedUrl = getLayoutInfo.processUrl(params)
  const {isOk, content} = await response(
    {
      method: getLayoutInfo.type,
      url: computedUrl,
      headerParams,
      option: {
        loadingOptions: false
      }
    }
  )
  if (isOk) {
    // todo 干掉
    content.objectApiName = params.objectApiName
    return content
  }
  throw new Error(`方法名: requestSchema, 请求schema失败, objectApiName: ${params.objectApiName}`)
}

/**
 * 方法名: requestSubObjectsSchema
 * 说明: 获取关联对象
 * 参数:
 * 1. params 对象  {curAuthCode,layoutApiName,objectApiName,tenantType,subObjectParamName} subObjectParamName 为数据id
 * 2. headerParams 对象 => 校验权限
 * */
export async function requestSubObjectsSchema (params, headerParams) {
  const api = Api.apaasGetRelationLayoutDetail
  const computedUrl = api.processUrl(params)
  const {isOk, content} = await response(
    {
      method: api.type,
      url: computedUrl,
      headerParams,
      option: {
        loadingOptions: false
      }
    }
  )
  if (isOk) {
    const {parentLayoutType} = params
    params.subObjectParamName = params.subObjectParamName || params.layoutApiName
    // 移动端从对象需要使用从对象名称  将主对象的subPages内的从对象的title赋值给当前从对象
    content.data.info.title =  params?.title
    if (parentLayoutType === LAYOUT_TYPE.LAYOUT_TYPE_POLYMERIC_DETAIL) {
      params.subObjectParamName = params.layoutApiName
    }
    if (parentLayoutType === LAYOUT_TYPE.LAYOUT_TYPE_POLYMERIC_CREATE) {
      params.subObjectParamName = params.layoutApiName
      content.data.info._objectApiName = content.data.info.objectApiName
      content.data.info.objectApiName = params.subObjectParamName
      content.data.info.layoutApiName =  params.layoutApiName
      params.objectApiName = params.subObjectParamName
      return assign(content, params)
    }
    // params.objectApiName = params.objectSeqCode
    return assign(content, params)
  }
  return Promise.resolve()
}

/**
 * 方法名: requestSubObjectsSchema
 * 说明: 值对象-一方对象中查找关联的布局信息
 * 参数:
 * 1. params 对象  {tenantType, oneObjectApiName, listLayoutApiName}
 * 2. headerParams 对象 => 校验权限
 * */
export async function requestLookUpRelationLayout (params, headerParams) {
  const api = Api.getRelationLayoutByField
  const computedUrl = api.processUrl(params)
  const {content, isOk} = await response(
    {
      method: api.type,
      url: computedUrl,
      params,
      headerParams: headerParams
    }
  )

  if (isOk) {
    return content
  }
}